import React from "react";
import axios from "axios";
import { withRouter } from "react-router-dom";
import { deserialise } from "kitsu-core";
import { view } from "react-easy-state";
import { Card, Tag, Icon, Tooltip, message } from "antd";

import globalStore from "store/index";

import { getAuthorization } from "api";

import Lightbox from "components/common/Lightbox/Index";
import MiniPlayer from "components/common/MiniPlayer/Index";
import CommentBox from "components/common/CommetBox/Index";

import AskDoubt from "components/pages/students/AskDoubt";

class DoubtDetails extends React.Component {
  componentDidMount() {}

  renderAttachments = (attachedFiles) => {
    console.log("attached file", attachedFiles);

    const images = attachedFiles.filter((f) => f.contentType.includes("image"));

    const audios = attachedFiles.filter((f) => f.contentType.includes("audio"));

    return (
      <div style={{ display: "flex" }}>
        <Lightbox images={images} />
        <MiniPlayer audios={audios} />
      </div>
    );
  };

  updateStore = (data) => {
    const showPageStoreData = globalStore.ui.students.doubts.show;

    if (showPageStoreData.doubt) {
      showPageStoreData.doubt.doubt_messages = data;
    }
  };

  handleEditDoubtButton = (doubt) => {};

  renderCardExtra = ({ doubt, currentUser }) => {
    if (doubt.picker_id) return <Tag>Doubt picked</Tag>;

    if (doubt.user.id === currentUser.id)
      return (
        <AskDoubt
          chapterId={this.props.match.params.doubtId}
          doubt={doubt}
          hideSubjectInput={true}
          buttonText="Edit doubt"
          buttonType="link"
          buttonStyle={{
            position: "initial",
            display: "flex",
            justifyContent: "flex-end",
          }}
        />
      );
  };

  handleLike = ({ doubtId, likedByCurrentUser }) => {
    axios
      .put(
        `${process.env.REACT_APP_API_BASE_URL}/api/students/doubts/${doubtId}/toggle_like`,
        {},
        {
          headers: {
            Authorization: getAuthorization(),
            "Content-Type": "multipart/form-data",
          },
        }
      )
      .then(async (response) => {
        const responseData = response.data;

        if (!responseData["doubt"]) {
          message.destroy();
          message.error("Couldn't like doubt.");
          this.setState({ submitting: false });
          return;
        }

        const deserialisedData = await deserialise(responseData["doubt"]);

        const showPageStoreData = globalStore.ui.students.doubts.show;

        if (deserialisedData.data) {
          showPageStoreData.doubt = deserialisedData.data;
        }

        if (!likedByCurrentUser) {
          message.destroy();
          message.success("You liked the doubt.");
        }
      })
      .catch((e) => {
        console.error("Error", e);
        this.setState({
          submiting: false,
        });
        message.destroy();
        message.error("Couldn't like doubt.");
      });
  };

  doubtCardTitle = ({ doubt, currentUser }) => {
    const likedByCurrentUser =
      doubt.likes.filter(
        (l) => parseInt(l.liker.id) === parseInt(currentUser.id)
      ).length > 0;

    return (
      <div
        style={{ display: "flex", flexDirection: "row", alignItems: "center" }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            marginRight: 15,
          }}
        >
          <span key="like">
            <Tooltip title={likedByCurrentUser ? "Dislike" : "Like"}>
              <Icon
                type="like"
                theme={likedByCurrentUser ? "filled" : "outlined"}
                onClick={() =>
                  this.handleLike({
                    doubtId: doubt.id,
                    likedByCurrentUser,
                  })
                }
              />
            </Tooltip>
            <span style={{ paddingLeft: 8, cursor: "auto" }}>
              {(doubt.likes && doubt.likes.length) || null}
            </span>
          </span>
        </div>
        Doubt - {doubt.subject && doubt.subject.name} >{" "}
        {doubt.chapter && doubt.chapter.name}
      </div>
    );
  };

  render() {
    const { doubt, user } = globalStore.ui.students.doubts.show;

    if (!doubt) {
      return null;
    }

    return (
      <div>
        <Card
          title={this.doubtCardTitle({ doubt, currentUser: user })}
          extra={this.renderCardExtra({ currentUser: user, doubt })}
          style={{ marginBottom: 30 }}
        >
          <p>{doubt.description}</p>
        </Card>
        <Card title="Attachments" style={{ marginBottom: 30 }}>
          {this.renderAttachments(doubt.attached_files)}
        </Card>
        <Card
          title={`Comments (${doubt.doubt_messages.length})`}
          style={{ marginBottom: 30 }}
        >
          <CommentBox
            doubt={doubt}
            updateStore={this.updateStore}
            currentUser={user}
            commentable={doubt.user.id === user.id}
          />
        </Card>
      </div>
    );
  }
}

export default withRouter(view(DoubtDetails));
